import type { Faq } from '../types/offer'

export const faqs: Faq[] = [
  {
    question: 'Is this only for freelancers?',
    answer:
      "No. This system works for freelancers, entrepreneurs, employees, students, and anyone wanting to adopt a champion mindset and earn more money. Whether you're starting a business or climbing the corporate ladder, this applies.",
  },
  {
    question: 'How long does it take to see results?',
    answer:
      'Most people see shifts in their thinking within 48 hours. Practical results (more clients, more money, better confidence) typically appear within 30 days if you implement the strategies consistently.',
  },
  {
    question: "What if I don't have time to read 400+ pages?",
    answer:
      'Each Tomo is designed to be consumed in chunks. Many customers read 15-20 minutes per day and finish within 2-3 weeks. Plus, you can use the Dictionary and Workbook as quick-reference guides.',
  },
  {
    question: 'Is this available in Bengali?',
    answer:
      'The core content is in English (premium quality), but we provide translated summaries and a complete dictionary with Bengali explanations.',
  },
  {
    question: "What if it doesn't work for me?",
    answer:
      "We offer a 7-day, no-questions-asked money-back guarantee. If you implement the strategies and don't see results, you get 100% refunded. We're that confident this works.",
  },
  {
    question: 'Can I share this with friends?',
    answer:
      'This is a personal license for individual use. However, we offer bulk discounts and team licenses if you want to share with your business or organization.',
  },
]
